/**
 * Window event signalling that a conversation was created in the background
 * (e.g. by an automation run) and the chat-history list should reconcile.
 *
 * The chat-history list has no live feed of its own — it only fetches on mount
 * / brand change. ``use-notification-toasts`` already polls ``/api/notifications``
 * and learns of automation completions; it fires this event so
 * ``ChatHistoryPanel`` reconciles page 1 without a second poll. Mirrors the
 * window-event bridge used by ``PUSH_STATE_CHANGED_EVENT``.
 */
export const CONVERSATION_LIST_DIRTY_EVENT = 'nex:conversation-list-dirty'
